import { useEventCallback } from 'usehooks-ts';

import { useControlledState } from '../../hooks';

import { DropdownFilterChangeHandler, DropdownOption } from './types';

type Props = {
  options: DropdownOption[];

  /**
   * By default FE sorting will be done based on `options` prop,
   * but if this value is specified we will view it as controlled sorting
   * (which can be BE sorting or whatever else parent component wants to do)
   */
  onChange: DropdownFilterChangeHandler | undefined;
};

type Result = [DropdownOption[], (filter: string) => void];

const useFilteredOptions = ({ options, onChange }: Props): Result => {
  const [filteredOptions, setFilteredOptions] =
    useControlledState<DropdownOption[]>(options);

  const changeFilter = useEventCallback((filter: string) => {
    // controlled
    if (onChange) {
      onChange(filter.trim());

      return;
    }

    // uncontrolled
    if (!filter) {
      setFilteredOptions(options);

      return;
    }

    setFilteredOptions(
      options.filter(item =>
        item.label.trim().toLowerCase().includes(filter.trim().toLowerCase()),
      ),
    );
  });

  return [filteredOptions, changeFilter];
};

export default useFilteredOptions;
